export default __webpack_public_path__ + "static/char-s-31-zh-Hant-bcb50a0a9e26338ff8c53b7105ce0062.webp";